import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        google: false,
        map: false,
        zoomLevel: window.screen.width <= 1024 ? 10 : 12,
        stores: [],
        userPosition: undefined,
        userAddress: '',
        fallbackPosition: {
            lat: 46.71109,
            lng: 1.7191036,
        },
        view: 'search',
        selectedStore: {
            name: 'Rougier&Plé Avignon',
            address: 'Centre Commercial Cap-Sud 162 avenue Pierre Sémard (au centre de la galerie)',
            zip_code: '84000 AVIGNON',
            phone: '04 32 44 81 09',
            location: {
                lat: 43.929102254804945,
                lng: 4.837560430687121,
            },
        },
    },
    getters: {
        stores: (state) => state.stores,
    },
    mutations: {
        SET_Stores(state, stores) {
            state.stores = stores;
        },
    },
    actions: {
        loadStores({ commit }) {
            axios
                .get('./stores.json')
                .then((response) => response.data.map((line) => ({ ...line, distance: 'Unable to get Distance to location' })))
                .then((stores) => {
                    commit('SET_Stores', stores);
                })
                .catch((err) => {
                    console.error('Looks like there was a problem while fetching the stores file.', err);
                });
        },
    },

});
